import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  VclAccordionModule,
  VclAlertModule,
  VclAutocompleteModule,
  VclCardTemplateModule,
  VclDatepickerModule,
  VclFormFieldModule,
  VclInputModule,
  VclModalModule,
  VclSelectModule,
  VclTableModule,
} from '@voxel/community';
import { VoxelMaskModule } from '@voxel/components';
import {
  VoxelCheckboxModule,
  VoxelFormFieldModule,
  VoxelInputModule,
  VoxelLinkModule,
  VoxelModalModule,
} from '@voxel/mobile';
import { LottieAnimationViewModule } from 'ng-lottie';

import { SharedModule } from '../../shared/shared.module';
import { AmountRequestComponent } from './amount-request/amount-request.component';
import { BackDocumentScanComponent } from './back-document-scan/back-document-scan.component';
import { DocumentScanSuccessComponent } from './document-scan-success/document-scan-success.component';
import { FingerPrintsScanComponent } from './finger-prints-scan/finger-prints-scan.component';
import { FrontDocumentScanComponent } from './front-document-scan/front-document-scan.component';
import { IdentificationRoutes } from './identification.routes';
import { MaxPeriodRequestComponent } from './max-period-request/max-period-request.component';
import { MicroSimulatorComponent } from './micro-simulator/micro-simulator.component';
import { OneTimePasswordComponent } from './one-time-password/one-time-password.component';
import { OtpProblemComponent } from './otp-problem/otp-problem.component';
import { PoliticallyExposedPersonComponent } from './politically-exposed-person/politically-exposed-person.component';
import { ProcessComponent } from './process/process.component';
import { MicroEvidenteMasterComponent } from './micro-evidente-master/micro-evidente-master.component';
import { RequestComponent } from './request/request.component';
import { AttachDocumentsComponent } from './attach-documents/attach-documents.component';
import { DocumentRequirementsComponent } from './document-requirements/document-requirements.component';
import { MaxProductsErrorComponent } from './max-products-error/max-products-error.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    VclModalModule,
    VoxelLinkModule,
    VoxelModalModule,
    VoxelCheckboxModule,
    IdentificationRoutes,
    VoxelFormFieldModule,
    VoxelInputModule,
    LottieAnimationViewModule.forRoot(),
    VclInputModule,
    VoxelMaskModule,
    VclFormFieldModule,
    ReactiveFormsModule,
    VclAlertModule,
    VclAutocompleteModule,
    VclCardTemplateModule,
    VclDatepickerModule,
    VclTableModule,
    VclSelectModule,
    VclAccordionModule,
  ],
  providers: [],
  declarations: [
    BackDocumentScanComponent,
    FrontDocumentScanComponent,
    FingerPrintsScanComponent,
    DocumentScanSuccessComponent,
    PoliticallyExposedPersonComponent,
    ProcessComponent,
    AmountRequestComponent,
    MaxPeriodRequestComponent,
    OneTimePasswordComponent,
    OtpProblemComponent,
    MicroSimulatorComponent,
    MicroEvidenteMasterComponent,
    RequestComponent,
    AttachDocumentsComponent,
    DocumentRequirementsComponent,
    MaxProductsErrorComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})

export class IdentificationModule { }
